<template lang="pug">
  .content-cartel-base
    img(src="/images/logo-01.svg")
</template>

<script>

export default {
  mounted() {

  }
}
</script>

<style lang="sass">
  .st6-letter
    fill: #FFFFFF
  .st0-logo
    fill: transparent
    stroke: #fff
    stroke-width: 13px
    fill-rule: evenodd
    clip-rule: evenodd
  .logo-ccm
    width: 70px
    position: absolute
    left: 49.5%
    top: 54px
    transform: translateX(-50%) skewX(-5deg)
    transition: all 1s ease
  .content-svg
    transform: translateY(-35%)
  .content-circle-cartel, .base-circle-cartel
    transform-origin: 246px 171px
  .content-circle-cartel
    animation: 1s moveCircleCartel ease
  .base-circle-cartel
    animation: 20s moveBaseCircleCartel ease-in-out infinite
    animation-delay: 1s
  .table-content-cartel
    animation: 1.5s fade ease
  .bulb-one
    animation: .3s fade ease infinite alternate
  .bulb-two
    animation: .3s fade ease infinite alternate
    animation-delay: .3s
  .bulb-three
    animation: .3s fade ease infinite alternate
    animation-delay: .4s
  .content-cartel-base
    width: 700px
    margin: auto
  .bulbs-left
    animation: .4s fadeBulbs ease infinite alternate
  .bulbs-right
    animation: .4s fadeBulbs ease infinite alternate
    animation-delay: .4s
</style>



// WEBPACK FOOTER //
// resources/js/components/PageConcurso2020/CartelImage.vue